<template>
	<p class="company-count">
		<span>Company count:</span>
		<span v-if="!search.recalculatingCount">
			{{search.resultStatus == 2 ? 'MAX' : search.resultStatus == 1 ? 'ERR' : search.resultCount}}
			<span v-if="search.resultStatus == 1" title="An error has occured whilst generating your result count"><font-awesome-icon class="too-large" :icon="exclamation" /></span>
			<span v-if="search.resultStatus == 2" title="Too many search results to calculate, please refine query"><font-awesome-icon class="too-large" :icon="exclamation" /></span>
			<span v-if="search.resultStatus == 3" title="Large results count, results might be slow to generate"><font-awesome-icon class="warn" :icon="exclamation" title="" /></span>
		</span>
		<span v-if="search.recalculatingCount || search.loadingResults"><font-awesome-icon icon="spinner" /></span>
	</p>
</template>

<script>
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
	import { faExclamationTriangle } from '@fortawesome/fontawesome-free-solid'

	

	export default {
		name: 'CompanyCount',
		components: {
			FontAwesomeIcon
		},
		props: ['search'],
		data() {
			return {
				exclamation: faExclamationTriangle
			}
		},
	}
</script>

<style lang="scss" scoped>	
	.company-count {
		margin: 0;
		padding: 7px 10px;
		border: 1px solid #e4e4e4;
		min-width: 250px;
		display:flex;

		.fa-spinner{
			margin:0;
			height:15px !important;
			width:15px !important;
			color:grey;
		}

		span {
			font-weight: bold;
			margin-right:5px;
		}

		@media only screen and (max-width: 800px) {
			min-width: initial;
		}
	}

	.too-large {
		color:orangered;
		cursor: help;
	}

	.warn {
		color: orange;
	}
</style>
